<template>
  <BlBackdrop
    title="Create new phase line"
    description="Specify the details of your new phase line."
    label="Create"
    :disabled="isDisabledSubmit"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onCreate"
  >
    <div class="flex flex-col gap-4 px-8">
      <div class="flex gap-4">
        <BlInputText :input="labelInput" @changed="inputHandler" />
        <div v-if="!isPrompting" class="relative">
          <label class="mb-1 relative">
            <BlTextBody3 text="Color" />
          </label>
          <div
            :data-id="`phase-line-color`"
            :class="colorOpened ? 'border-light-purple ' : 'border-grey-200 '"
            class="relative h-10 w-24 px-4 flex items-center justify-between border rounded cursor-pointer"
            @click.prevent="colorOpened = !colorOpened"
          >
            <div
              class="w-6 h-6 flex-shrink-0 rounded-full"
              :style="{backgroundColor: phaseLineColors[colorInput]}"
            />
            <BlIcon
              :data-id="`phase-line-color`"
              class="absolute right-4 w-5 h-5 transition-all duration-300"
              icon="chevron-down"
              :style="colorOpened ? 'rotate: 180deg' : ''"
            />
          </div>
          <div
            :data-id="`phase-line-color`"
            v-if="colorOpened"
            class="absolute right-0 w-38 max-h-48 mt-2 z-10 py-4 pl-4 bg-pure-white rounded border border-grey-200 shadow-md"
          >
            <div :data-id="`phase-line-color`">
              <div :data-id="`phase-line-color`" class="flex flex-wrap gap-2">
                <button
                  v-for="color in Object.keys(phaseLineColors)"
                  :key="color"
                  class="h-6 w-6 flex-shrink-0 rounded border-2 outline-none"
                  :class="
                    color === colorInput
                      ? 'border-light-purple'
                      : 'border-transparent'
                  "
                  :style="{ backgroundColor: phaseLineColors[color] }"
                  @click.prevent="colorInput = color"
                  :title="color"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <BlInputText :input="descriptionInput" @changed="inputHandler" />
      <div
        v-if="!hasPhaseLine"
        class="w-156 p-2 bg-info-100 text-info rounded flex items-center gap-2 text-sm"
      >
        <BlIcon icon="toast-info" class="flex-shrink-0 w-6" />
        <BlTextBody1
          text="Creating a phase line for the first time? We'll set up a baseline for you that you can edit later."
        />
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions } from "vuex";

import BlTextBody1 from "../../../BlTextBody1.vue";
import BlTextBody3 from "../../../BlTextBody3.vue";
import BlInputText from "../../../BlInputText.vue";
import BlBackdrop from "../../../BlBackdrop.vue";
import BlIcon from "../../../BlIcon.vue";

export default {
  name: "NewPhaseLineModal",
  components: {
    BlTextBody1,
    BlTextBody3,
    BlInputText,
    BlBackdrop,
    BlIcon
  },
  props: ["targetId", "hasPhaseLine", "isPrompting"],
  data() {
    return {
      submitLoading: false,
      labelInput: {
        label: "Label",
        asterisk: true,
        placeholder: "Type the label for the phase line",
        model: ""
      },
      colorOpened: false,
      colorInput: "lake",
      phaseLineColors: {
        lake: "#2AB1A8",
        tangerine: "#F57E00",
        cherry: "#FF4447",
        sky: "#487ADF",
        moss: "#A7C957",
        gold: "#F4D430",
        salmon: "#F4855D",
        primary: "#9A8AC2"
      },
      descriptionInput: {
        label: "Description",
        placeholder: "Type the phase description",
        textarea: true,
        model: ""
      }
    };
  },
  computed: {
    isDisabledSubmit() {
      if (this.submitLoading) return true;
      if (!this.labelInput.model) return true;
      return false;
    }
  },
  watch: {
    colorOpened(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandler);
        }, 10);
      }
    }
  },
  mounted() {
    // reset state
    this.labelInput.model = "";
    this.colorInput = "lake";
    this.descriptionInput.model = "";
  },
  methods: {
    ...mapActions(["createPhaseLine"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    onCreate() {
      this.submitLoading = true;
      const params = {
        line_label: this.labelInput.model,
        line_color: this.colorInput,
        line_description: this.descriptionInput.model
      };
      this.createPhaseLine({
        targetId: this.targetId,
        phaseLine: params
      }).then(() => {
        this.submitLoading = false;
        this.$emit("close-modal");
      });
    },
    closeHandler(e) {
      let close = true;
      if (e.target && e.target.dataset && e.target.dataset.id) {
        const id = e.target.dataset.id || "";
        if (`phase-line-color` === id) close = false;
      }
      if (close) {
        window.removeEventListener("click", this.closeHandler);
        this.colorOpened = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/target/modal/NewPhaseLineModal.vue